<template>
  <el-form-item label="Video Source" size="small">
    <el-radio-group
      v-if="isDesktop"
      v-model="value"
      class="desktop"
      :disabled="disabled"
      @update:modelValue="input"
    >
      <el-radio-button
        v-for="videoLabel in VideoSourceLabels"
        :key="videoLabel.type"
        :value="videoLabel.type"
      >
        {{ videoLabel.label }}
      </el-radio-button>
    </el-radio-group>
    <el-select
      v-else
      v-model="value"
      :disabled="disabled"
      @update:modelValue="input"
    >
      <el-option
        v-for="videoLabel in VideoSourceLabels"
        :key="videoLabel.type"
        :label="videoLabel.label"
        :value="videoLabel.type"
      >
        {{ videoLabel.label }}
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { VideoSourceLabels } from '@/api/types'
import useResize from '@/hooks/useResize'

type Preview = {
  name: string
  url: string
}

export default defineComponent({
  name: 'VideoSelector',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Number,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const { isDesktop } = useResize()
    const input = (newValue: number) => {
      context.emit('update:modelValue', Number(newValue))
    }
    return { isDesktop, VideoSourceLabels, input, value }
  }
})
</script>
